<template>
    <div class="d-flex">
        <div class="form-check form-check-inline">
            <input
                id="input-empty-yes"
                v-model="valueComponent"
                type="radio"
                :value="true"
                class="form-check-input"
            />
            <label class="form-check-label" for="input-empty-yes">
                {{ "Yes" }}
            </label>
        </div>
        <div class="form-check form-check-inline">
            <input
                id="input-empty-no"
                v-model="valueComponent"
                type="radio"
                :value="false"
                class="form-check-input"
            />
            <label class="form-check-label" for="input-empty-no">
                {{ "No" }}
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: "CCQueryBuilderRuleTypeEmpty",
    components: {},

    data() {
        return {
            valueComponent: null,
        };
    },

    watch: {
        value(newValue) {
            this.valueComponent = newValue;
        },
        valueComponent(newValue) {
            this.$emit("update:value", newValue);
            this.$emit("change", newValue);
        },
    },

    props: {
        value: {
            required: true,
        },
        placeholder: {
            type: String,
        },
    },

    mounted() {
        this.valueComponent = this.value;
    },
};
</script>
